import { Box, Button, Image, Text } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import errorImage from "../assets/images/error-image.png";

function ErrorPage() {
  const navigate = useNavigate();
  return (
    <Box
      display={"flex"}
      justifyContent="center"
      alignItems={"center"}
      marginTop="5rem"
    >
      <Box display={"block"}>
        <Box>
          <Image src={errorImage} width="600px" height={"400px"} />
        </Box>
        <Box>
          <Text
            color={"#514898"}
            fontSize="5xl"
            fontWeight={"800"}
            fontFamily={"font.roboto"}
            display={"flex"}
            justifyContent="center"
          >
            ERROR 404
          </Text>
          <Text
            color={"#9552FF"}
            fontSize="xl"
            fontWeight={"400"}
            fontFamily={"font.roboto"}
            display={"flex"}
            justifyContent="center"
          >
            Page you’re Looking doesn’t Exists
          </Text>
          <Box display={"flex"} justifyContent="center" marginTop={"2rem"}>
            <Button
              w="150px"
              bg="#4788D6"
              color={"#fff"}
              _hover={{ bg: "#52BBFF" }}
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default ErrorPage;
